export default __webpack_public_path__ + "static/media/wells-fargo-logo.a46fc645.png";